import { ETheme, EThemeBackground } from "@/common/entity/Enum";
import styled from "styled-components";

export const BaseListResourceWrapper = styled.div<{ $maxHeight?: number; $theme?: string }>`
  width: 100%;
  max-height: ${(props) => props.$maxHeight || 300}px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    position: sticky;
    width: 3px;
    height: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const ResourceInfoWrapper = styled.div<{ $isAcceptSelect?: boolean; $theme?: string; $isLastChild?: boolean }>`
  cursor: ${(props) => props.$isAcceptSelect ? "pointer" : "not-allowed"};
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: ${props => props.$isLastChild ? "0px" : "8px"};
`;

export const StickyElementWrapper = styled.div<{$theme?: string}>`
  height: 40px;
  margin-left: -2px;
  overflow-x: hidden;
  position: sticky;
  bottom: 0;
  padding: 0px 15px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  background: ${props => props.$theme === ETheme.Dark ? EThemeBackground.Dark : EThemeBackground.Light};
`;

export const LoadMoreWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  width: 100%;
  font-weight: 400;
  font-style: normal;
  cursor: pointer;
  color: #0072c6;
  margin-bottom: 4px;
`;
